import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicy = () => {
  // Scroll to top when page opens
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Navbar />

      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: January 4, 2026</p>

        <div className={styles.section}>
          <p>
            At Dukamo Coffee, your privacy is important to us. This Privacy
            Policy explains how we collect, use, and protect your personal
            information when you visit our website or purchase our premium
            coffee products.
          </p>
        </div>

        <div className={styles.section}>
          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us, such as when you
            create an account, place an order, or sign up for our newsletter.
            This may include:
          </p>
          <ul>
            <li>Name and contact information (email, phone number).</li>
            <li>Shipping and billing addresses.</li>
            <li>
              Payment information (processed securely by our payment partners).
            </li>
            <li>Order history and preferences.</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process and fulfill your coffee orders.</li>
            <li>Communicate with you about your order status and shipping.</li>
            <li>
              Send you updates, newsletters, and promotional offers (if you
              opted in).
            </li>
            <li>Improve our website and customer service experience.</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>3. Sharing of Information</h2>
          <p>
            We do not sell your personal data. We only share your information
            with trusted third-party service providers necessary to operate our
            business, such as:
          </p>
          <ul>
            <li>
              Payment processors (e.g., SantimPay, Telebirr) to handle
              transactions.
            </li>
            <li>Logistics partners to deliver your package.</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>4. Cookies</h2>
          <p>
            Our website uses cookies to enhance your browsing experience,
            analyze site traffic, and personalize content. You can choose to
            disable cookies through your browser settings, though this may
            affect some site functionality.
          </p>
        </div>

        <div className={styles.section}>
          <h2>5. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at{" "}
            <a href="mailto:support@dukamocoffee.com" className={styles.link}>
              support@dukamocoffee.com
            </a>
            .
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
